import { render } from "./user-center.vue?vue&type=template&id=3eea0d5e&scoped=true"
import script from "./user-center.vue?vue&type=script&lang=js"
export * from "./user-center.vue?vue&type=script&lang=js"

import "./user-center.vue?vue&type=style&index=0&id=3eea0d5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eea0d5e"]])

export default __exports__